import axios from 'axios';

import router from '@/router';
import auth from '@/utils/auth';

import {
  DELETE_EVENT,
  DELETE_EVENT_ERROR,
  DELETE_EVENT_SUCCESS,

  GET_EVENT,
  GET_EVENT_ERROR,
  GET_EVENT_SUCCESS,

  SAVE_EVENT,
  SAVE_EVENT_ERROR,
  SAVE_EVENT_SUCCESS,

  GET_ALL_EVENT,
  GET_ALL_EVENT_ERROR,
  GET_ALL_EVENT_SUCCESS,

} from './constants';

export default {
  async [DELETE_EVENT]({ commit }, data) {
    try {
      commit(DELETE_EVENT);
      await axios({
        url: `${process.env.API_URL}/api/events/${data}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_EVENT_SUCCESS);
      router.push({ name: 'Information Calender' });
    } catch (err) {
      commit(DELETE_EVENT_ERROR, err);
    }
  },

  async [GET_EVENT]({ commit }, data) {
    try {
      commit(GET_EVENT);
      const response = await axios({
        url: `${process.env.API_URL}/api/events/${data}`,
        method: 'GET',
        headers: auth.getAuthHeader(),

      });
      commit(GET_EVENT_SUCCESS, response.data);
    } catch (err) {
      commit(GET_EVENT_ERROR, err);
    }
  },

  async [GET_ALL_EVENT]({ commit }, data) {
    try {
      commit(GET_ALL_EVENT);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${data}/events`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_ALL_EVENT_SUCCESS, response.data);
    } catch (err) {
      commit(GET_ALL_EVENT_ERROR, err);
    }
  },

  async [SAVE_EVENT]({ commit }, data) {
    try {
      commit(SAVE_EVENT);
      let url = `${process.env.API_URL}/api/events`;
      let method = 'POST';
      if (data.eventID) {
        url = `${url}/${data.eventID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_EVENT_SUCCESS, response.data);
      if (method === 'POST' && response.data.syndicateID) {
        router.push({ name: 'Syndicate Dashboard', params: { syndicateID: response.data.syndicateID } });
      }
    } catch (err) {
      commit(SAVE_EVENT_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Calendar/actions.js